import styled from 'styled-components';

type Props = {
  hasError?: boolean;
};
export default styled.textarea<Props>`
  border: 1px solid
    ${({ theme, hasError }): string =>
      hasError ? theme.colors.danger : theme.colors.separatorOnWhite};
  box-sizing: border-box;
  border-radius: 4px;
  height: 74px;
  width: 100%;
  resize: none;
  padding: 8px 10px;
  margin-top: 10px;

  &:focus {
    outline: none;
  }

  &::placeholder,
  &::-webkit-input-placeholder {
    color: ${(props) => props.theme.colors.gray};
    opacity: 0.5;
  }
`;
